export interface AttachmentProvider {
  name: string;
  iconClass: string;
}

export function deriveFileNameFromUrl(url: string): string {
  if (!url) return '';
  let parsed: URL;
  try {
    parsed = new URL(url.trim());
  } catch (e) {
    return '';
  }
  const host = (parsed.hostname || '').toLowerCase();
  const segments = parsed.pathname.split('/').filter(Boolean);
  const last = segments.length ? segments[segments.length - 1] : '';
  let decoded = '';
  try {
    decoded = decodeURIComponent(last);
  } catch (e) {
    decoded = last;
  }
  if (decoded && /\.[A-Za-z0-9]{1,8}$/.test(decoded)) return decoded;
  if (host === 'drive.google.com') return 'Google Drive document';
  if (host === 'docs.google.com') return 'Google Docs document';
  if (host === 'onedrive.live.com' || host.endsWith('.sharepoint.com')) return 'OneDrive document';
  return host || 'Cloud document';
}

export function detectAttachmentProvider(url: string): AttachmentProvider {
  if (!url) return { name: '', iconClass: 'fas fa-cloud' };
  let host = '';
  try {
    host = new URL(url.trim()).hostname.toLowerCase();
  } catch (e) {
    return { name: '', iconClass: 'fas fa-cloud' };
  }

  if (host.endsWith('dropbox.com')) return { name: 'Dropbox', iconClass: 'fab fa-dropbox' };
  if (host === 'drive.google.com') return { name: 'Google Drive', iconClass: 'fab fa-google-drive' };
  if (host === 'docs.google.com') return { name: 'Google Docs', iconClass: 'fab fa-google-drive' };
  if (host === 'onedrive.live.com') return { name: 'OneDrive', iconClass: 'fab fa-microsoft' };
  if (host.endsWith('.sharepoint.com')) return { name: 'SharePoint', iconClass: 'fab fa-microsoft' };

  return { name: host, iconClass: 'fas fa-cloud' };
}

export function fileIconClass(fileName: string): string {
  if (!fileName) return 'fas fa-file';
  const ext = (fileName.split('.').pop() || '').toLowerCase();
  switch (ext) {
    case 'pdf':
      return 'fas fa-file-pdf';
    case 'doc':
    case 'docx':
      return 'fas fa-file-word';
    case 'xls':
    case 'xlsx':
    case 'csv':
      return 'fas fa-file-excel';
    case 'ppt':
    case 'pptx':
      return 'fas fa-file-powerpoint';
    case 'png':
    case 'jpg':
    case 'jpeg':
    case 'gif':
    case 'webp':
    case 'bmp':
      return 'fas fa-file-image';
    case 'zip':
    case 'rar':
    case '7z':
      return 'fas fa-file-archive';
    case 'txt':
      return 'fas fa-file-alt';
    default:
      return 'fas fa-file';
  }
}
